import {
  BRAND_STORE, BrandStore,
  PRODUCT_STORE, ProductStore,
  GENERAL_STORE, GeneralStore

} from 'store'
import { OverrideProperty } from 'utilities'
import { Product } from 'models'

export interface Props {
  [BRAND_STORE]?: BrandStore
  [PRODUCT_STORE]?: ProductStore
  [GENERAL_STORE]?: GeneralStore
  product?: Product
}

export type StateProduct = OverrideProperty<Product, 'tags', string[]>

export const newProduct = {
  name: '',
  brandId: null,
  brandName: null,
  tags: [],
  info: '',
  images: [],
  productSkus: [],
  attGroups: [],
  relatedMedia: []
} as StateProduct
